import { useAppointmentSchedulerStore } from '../../stores/appointment-scheduler-store';
import { RouteOptionList } from './RouteOptionList';

export function AlsoDeliverToggle() {
  const alsoDeliver = useAppointmentSchedulerStore((s) => s.alsoDeliver);
  const toggle = useAppointmentSchedulerStore((s) => s.toggleAlsoDeliver);
  const routes = useAppointmentSchedulerStore((s) => s.deliveryRoutes);
  const selectedId = useAppointmentSchedulerStore((s) => s.deliverySelectedRouteId);
  const setSelected = useAppointmentSchedulerStore((s) => s.selectDeliveryRoute);
  const isLoading = useAppointmentSchedulerStore((s) => s.isLoadingDeliveryRoutes);
  const error = useAppointmentSchedulerStore((s) => s.deliveryRoutesError);
  const showExtra = useAppointmentSchedulerStore((s) => s.deliveryShowExtra);
  const toggleExtra = useAppointmentSchedulerStore((s) => s.toggleDeliveryShowExtra);
  const notes = useAppointmentSchedulerStore((s) => s.deliveryNotes);
  const setNotes = useAppointmentSchedulerStore((s) => s.setDeliveryNotes);
  const openCapacityBump = useAppointmentSchedulerStore((s) => s.openCapacityBump);

  return (
    <div className="border border-slate-200 rounded-lg p-4 space-y-3 bg-slate-50/40">
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={alsoDeliver}
          onChange={toggle}
          className="accent-indigo-600"
        />
        <span className="text-sm font-medium text-slate-900">Ook aflevermoment plannen</span>
      </label>

      {alsoDeliver && (
        <div className="space-y-3 pt-1">
          <RouteOptionList
            routes={routes}
            selectedId={selectedId}
            onSelect={setSelected}
            showExtra={showExtra}
            onToggleExtra={toggleExtra}
            isLoading={isLoading}
            error={error}
            onBumpCapacity={(routeId) => openCapacityBump(routeId, 'delivery')}
          />

          <div className="space-y-1.5">
            <label className="text-xs font-medium text-slate-600 block">Opmerkingen afleveren</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Voor de chauffeur..."
              rows={2}
              className="w-full px-3 py-2 text-sm border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none"
            />
          </div>
        </div>
      )}
    </div>
  );
}
